import React from 'react';

import Background from '../../components/UI/Background/Background';

import AuthForm from '../components/Auth/AuthForm';

const AuthPage = () => {
  return <>
    <Background />
    <AuthForm />;
  </>
};

export default AuthPage;
